document.addEventListener("DOMContentLoaded", function () {
    const faqItems = document.querySelectorAll(".faq__block");

    faqItems.forEach(item => {
        const panel = item.querySelector(".faq__block-text");

        panel.style.maxHeight = "51px";

        item.addEventListener("click", function () {
            const isOpen = this.classList.contains("open");

            faqItems.forEach(el => {
                const p = el.querySelector(".faq__block-text");

                if (el.classList.contains("open")) {
                    p.style.maxHeight = p.scrollHeight + "px";

                    requestAnimationFrame(() => {
                        p.style.maxHeight = "51px";
                    });

                    p.addEventListener(
                        "transitionend",
                        () => {
                            if (!el.classList.contains("open")) {
                                p.style.webkitLineClamp = "2";
                            }
                        },
                        { once: true }
                    );
                }

                el.classList.remove("open");
            });

            if (!isOpen) {
                this.classList.add("open");

                panel.style.webkitLineClamp = "unset";

                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        });
    });
});